import { Icon } from '@zenchef/ds-react'
import { BoxProps } from '@zenchef/styled-system/jsx'
import { ForwardedRef, forwardRef } from 'react'

interface InformationIconProps extends BoxProps {
  isDisabled?: boolean
}

const InformationIcon = forwardRef(
  ({ isDisabled = false, ...props }: InformationIconProps, ref: ForwardedRef<HTMLElement>) => {
    return (
      <>
        <Icon
          name='info-circle'
          ref={ref}
          display='inline-flex'
          alignItems='center'
          justifyContent='center'
          fontSize='16px'
          color={isDisabled ? 'content.neutral.base.subtlest' : 'content.neutral.base.bold'}
          {...props}
        />
      </>
    )
  }
)

InformationIcon.displayName = 'InformationIcon'

export default InformationIcon
